/**
 * @generated SignedSource<<6a0ff7cd83606b406c54bd970f933e48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type starredFiltersList_navigationAppsSidebarCommon$data = {
  readonly favouriteFilters: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly filterId: string;
        readonly " $fragmentSpreads": FragmentRefs<"filterItem_navigationAppsSidebarCommon">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "starredFiltersList_navigationAppsSidebarCommon";
};
export type starredFiltersList_navigationAppsSidebarCommon$key = {
  readonly " $data"?: starredFiltersList_navigationAppsSidebarCommon$data;
  readonly " $fragmentSpreads": FragmentRefs<"starredFiltersList_navigationAppsSidebarCommon">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "starredFiltersList_navigationAppsSidebarCommon",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraFilterConnection",
      "kind": "LinkedField",
      "name": "favouriteFilters",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraFilterEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "filterId"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "filterItem_navigationAppsSidebarCommon"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "a0c4e11d2fa2d823ad4cac3d7e350cb3";

export default node;
